
<div class="access-content" routerLink="/principal/inicio" routerLinkActive="access-content--active" gtagEvent="ver-inicio" gtagCategory="general-widget">
	<div class="access-content__data-icon"><div class="inicio-icon"></div></div>
	<div class="access-content__data">Inicio</div>
</div>
<!-- <ng-container *ngIf="!( isUsuarioExterno$ | async )">
	<div class="access-content" [managedLink]="recursosHumanosKey" gtagEvent="ver-recursos-humanos" gtagCategory="general-widget">
		<div class="access-content__data-icon"><div class="self-service-icon"></div></div>
		<div class="access-content__data">Recursos Humanos</div>
	</div>
</ng-container> -->
<div class="access-content" [managedLink]="misCursosKey" gtagEvent="ver-mis-cursos" gtagCategory="general-widget">
	<div class="access-content__data-icon"><div class="mis-cursos-icon"></div></div>
	<div class="access-content__data">Mis cursos</div>
</div>